import Reveal from "@/components/base/Reveal";

export default function BrandStory() {
  return (
    <section className="w-full bg-background-100" aria-label="História da marca Amora Belle">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal className="order-2 lg:order-1">
            <span className="flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-accent-700">
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-leaf-line text-[11px]" />
              </span>
              Nossa essência
            </span>
            <h2 className="mt-4 font-heading text-3xl font-medium leading-tight text-foreground-900 md:text-4xl">
              Moda feita para mulheres reais
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              A Amora Belle nasceu como um conceito de moda feminina que valoriza escolhas pessoais, conforto e
              confiança. Cada detalhe desta experiência foi pensado para tornar a descoberta de novas peças mais leve,
              próxima e inspiradora.
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              Acreditamos que vestir bem é se sentir bem — com peças que acompanham o seu corpo, o seu momento e a sua
              história, sem abrir mão da delicadeza.
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4">
              {[
                { value: "Diversidade", label: "de corpos e estilos" },
                { value: "Cuidado", label: "em cada detalhe" },
                { value: "Proximidade", label: "no atendimento" },
              ].map((stat) => (
                <div key={stat.value} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <p className="font-heading text-xl text-primary-700">{stat.value}</p>
                  <p className="mt-1 text-[11px] leading-snug text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={120} className="order-1 lg:order-2">
            <div className="relative h-[360px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20behind%20the%20scenes%20photo%20of%20a%20clothing%20rack%20with%20feminine%20garments%20in%20warm%20plum%20cream%20and%20beige%20tones%2C%20a%20hand%20organizing%20soft%20fabrics%20in%20a%20minimal%20warm%20atelier%20with%20natural%20daylight%2C%20no%20text%2C%20no%20logos&width=900&height=1100&seq=amora-historia-bastidores-01&orientation=portrait"
                alt="Arara de roupas femininas organizada no ateliê da Amora Belle"
                title="Bastidores Amora Belle — organização de peças femininas"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}